import axios from 'axios'

/**
 * 会员相关API
 * 处理与会员服务相关的接口请求
 */
export default {
 // 创建会员订单
  createMembershipOrder(userId, membershipType) {
    return axios.post('/auth-service/api/membership/order', null, {
      params: { userId, membershipType }
    });
  },
  
  // 支付会员订单
  payMembershipOrder(orderNo) {
    return axios.post('/auth-service/api/membership/pay', null, {
      params: { orderNo }
    });
  },
  
  // 查看会员详情
  getMembershipDetail(userId) {
    return axios.get('/auth-service/api/membership/info', {
      params: { userId }
    });
  },
  
  // 获取会员订单列表
  getMembershipOrders(userId) {
    return axios.get('/auth-service/api/membership/orders', {
      params: { userId }
    });
  },
  
  // 检查是否为会员
  isVip(userId) {
    return axios.get('/auth-service/api/membership/is-vip', {
      params: { userId }
    });
  }
}